import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getPaymentPrice = (state: StateScheme) => {
    return state.payment.price
}
